$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('main-footer')) {
    customElements.define(
      'main-footer',
      class ProductForm extends HTMLElement {
        form = null;
        submitBtn = null;
        constructor() {
          super();
        }
        connectedCallback() {
          // 初始检测
          if (window.innerWidth <= 1200) {
            this.init();
            this.logoCarousel();
          }

          // 添加resize监听
          this.resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            if (width <= 1200 && !this.carouselInitialized) {
              this.logoCarousel();
              this.carouselInitialized = true;
            } else if (width > 1200 && this.carouselInitialized) {
              this.destroyCarousel();
              this.carouselInitialized = false;
            }
          });

          this.resizeObserver.observe(document.documentElement);
        }

        init() {
          const _this = this;
          const $footerMenuTitle = $('.footer_menu_title');
          $footerMenuTitle.on('click', function () {
            // 获取this同级的footer_menu_content
            const $footerMenuContent = $(this.nextElementSibling);
            const status = $(this).attr('data-status');
            if (status === 'close') {
              $footerMenuTitle.each(function () {
                if ($(this).attr('data-status') === 'open') {
                  $(this).attr('data-status', 'close');
                  const footerMenuItem = $(this.nextElementSibling);
                  footerMenuItem.css('height', 0);
                  $(this).find('.link_add').removeClass('hidden');
                  $(this).find('.link_remove').addClass('hidden');
                }
              });
              $(this).attr('data-status', 'open');
              $footerMenuContent.css('height', 'auto');
              const newHeight = $footerMenuContent.height();
              $footerMenuContent.css('height', 0);
              setTimeout(() => {
                $(this).find('.link_add').addClass('hidden');
                $(this).find('.link_remove').removeClass('hidden');
                $footerMenuContent.css('height', newHeight + 'px');
              }, 0);
            } else {
              $(this).attr('data-status', 'close');
              $footerMenuContent.css('height', 0);
              $(this).find('.link_add').removeClass('hidden');
              $(this).find('.link_remove').addClass('hidden');
            }
          });

          this.form = $(this.querySelector('#footer_subscribe'));
          this.submitBtn = this.form.find('[type="submit"]');
        }
        logoCarousel() {
          try {
            const shouldInit = window.matchMedia('(max-width: 1200px)').matches;
            if (!shouldInit) {
              return;
            }

            const container = this.querySelector('.carousel-container');
            const footer_slider = this.querySelector('.footer_slider');

            // 先清理所有旧的克隆元素，避免重复累积
            const existingClones = footer_slider.querySelectorAll('[data-cloned]');
            existingClones.forEach((clone) => clone.remove());

            // 添加安全宽度限制
            if (container.offsetWidth >= 1200) {
              return;
            }

            if (footer_slider.offsetParent === null) {
              console.warn('Carousel is hidden, retrying...');
              setTimeout(() => this.logoCarousel(), 300);
              return;
            }

            // 只选择非克隆的图片
            const images = Array.from(footer_slider.querySelectorAll('picture:not([data-cloned])')).filter(
              (img) => img.offsetWidth > 0
            );

            if (images.length === 0) {
              console.warn('No valid images found');
              return;
            }

            const gapString = window.getComputedStyle(footer_slider).gap || '0';
            const gap = parseInt(gapString.replace('px', '')) || 0;

            // 计算总宽度，注意每张图宽度加gap，最后一张不加gap
            const totalWidth = images.reduce((acc, img, index) => {
              const width = img.offsetWidth || 0;
              // 最后一张不加gap
              return acc + width + (index < images.length - 1 ? gap : 0);
            }, 0);
            if (totalWidth > container.offsetWidth) {
              // 双倍宽度用于无限滚动
              const actualTotalWidth = totalWidth * 2;

              if (actualTotalWidth > 1e6 || actualTotalWidth <= 0) {
                return;
              }

              footer_slider.style.width = `${actualTotalWidth}px`;
              footer_slider.style.animation = `footer_slider ${images.length * 3}s linear infinite`;

              // 克隆节点，且标记data-cloned
              const cloneNodes = images.map((img) => {
                const clone = img.cloneNode(true);
                clone.setAttribute('data-cloned', 'true');
                return clone;
              });
              cloneNodes.forEach((clone) => footer_slider.appendChild(clone));

              // 强制重绘
              void footer_slider.offsetHeight;
            } else {
              footer_slider.style.animation = 'none';
              footer_slider.style.removeProperty('width');
            }

            // 只绑定一次resize事件
            if (!this.resizeHandlerBound) {
              this.resizeHandlerBound = true;
              window.addEventListener('resize', () => {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => this.logoCarousel(), 100);
              });
            }
          } catch (error) {
            console.error('Carousel initialization failed:', error);
          }
        }

        ClickSubmit(e) {
          e.preventDefault();
          e.stopPropagation();
          this.handleSubmit(e);
        }

        handleSubmit(e) {
          const form = document.querySelector('.labs-form-el');
          form.addEventListener('submit', function (event) {
            event.preventDefault(); // 阻止默认表单提交

            const formData = new FormData(form);
            const action = form.action;

            // 添加 ReCaptcha V3 令牌
            window.Shopify.recaptchaV3.addToken(form, 'customer', function () {
              // 验证令牌添加成功后提交表单
              fetch(action, {
                method: 'POST',
                body: formData,
              })
                .then((response) => {
                  if (response.ok) {
                    form.reset(); // 清空表单
                  } else {
                    // 提交失败
                  }
                })
                .catch((error) => {
                  // 网络或其他错误
                });
            });
          });
        }

        destroyCarousel() {
          const footer_slider = this.querySelector('.footer_slider');
          if (footer_slider) {
            footer_slider.style.animation = 'none';
            footer_slider.style.width = 'auto';
            // 移除克隆元素
            const clones = footer_slider.querySelectorAll('[data-cloned]');
            clones.forEach((clone) => clone.remove());
          }
        }
      }
    );
  }
});
